var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgNotificationsblack(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 16,
    height: 16.6,
    viewBox: "0 0 16 16.6",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Color",
    d: "M8,16.6a3.331,3.331,0,0,1-3.555-3.037V13.28H1.455a1.456,1.456,0,0,1-1.344-.838,1.29,1.29,0,0,1,.314-1.479l1.6-1.5V5.583a5.435,5.435,0,0,1,2.047-4.2A6.22,6.22,0,0,1,8.011,0,6.411,6.411,0,0,1,8.8.049a5.824,5.824,0,0,1,5.174,5.708V9.465l1.6,1.5a1.287,1.287,0,0,1,.313,1.48,1.453,1.453,0,0,1-1.342.837h-2.99v.283A3.331,3.331,0,0,1,8,16.6ZM6,12.912v.314a1.838,1.838,0,0,0,2,1.531,1.838,1.838,0,0,0,2-1.531v-.314ZM7.992,1.845a4.525,4.525,0,0,0-2.86.99,3.862,3.862,0,0,0-1.5,3.006V9.794a1.61,1.61,0,0,1-.543,1.2L2,11.989H14l-1.093-1a1.608,1.608,0,0,1-.542-1.2V6.018A4.228,4.228,0,0,0,8.589,1.881,5.012,5.012,0,0,0,7.992,1.845Z",
    transform: "translate(0)"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_1",
    "data-name": "Group 1",
    transform: "translate(4601 3056)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Color-2",
    "data-name": "Color",
    d: "M8,16.6a3.331,3.331,0,0,1-3.555-3.037V13.28H1.455a1.456,1.456,0,0,1-1.344-.838,1.29,1.29,0,0,1,.314-1.479l1.6-1.5V5.583a5.435,5.435,0,0,1,2.047-4.2A6.22,6.22,0,0,1,8.011,0,6.411,6.411,0,0,1,8.8.049a5.824,5.824,0,0,1,5.174,5.708V9.465l1.6,1.5a1.287,1.287,0,0,1,.313,1.48,1.453,1.453,0,0,1-1.342.837h-2.99v.283A3.331,3.331,0,0,1,8,16.6ZM6,12.912v.314a1.838,1.838,0,0,0,2,1.531,1.838,1.838,0,0,0,2-1.531v-.314ZM7.992,1.845a4.525,4.525,0,0,0-2.86.99,3.862,3.862,0,0,0-1.5,3.006V9.794a1.61,1.61,0,0,1-.543,1.2L2,11.989H14l-1.093-1a1.608,1.608,0,0,1-.542-1.2V6.018A4.228,4.228,0,0,0,8.589,1.881,5.012,5.012,0,0,0,7.992,1.845Z",
    transform: "translate(-4601 -3056)"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNotificationsblack);
export default __webpack_public_path__ + "static/media/notificationsblack.b950505a.svg";
export { ForwardRef as ReactComponent };